import React, {useLayoutEffect, useRef, useState} from 'react';
import {IconButton, Tooltip} from '@mui/material';
import EditNote from '@mui/icons-material/RateReviewOutlined';
import Send from '@mui/icons-material/Send';
import api from '@src/api/axiosInstance';
import PubSub from 'pubsub-js';
import {EVENT_TOPIC_FORCE_REFRESH_CHAT} from '@src/Constants';
import {TypeBox} from './ChatFooter.styles';

// Tab-local and staff/conversation-scoped. Never use the WhatsApp draft store.
const drafts = new Map<string,{text:string;requestId:string}>();
export default function InternalNoteComposer({waId,staffId,onClose}:{waId:string;staffId:number;onClose:()=>void}) {
 const key=staffId+':'+waId;
 const [draft,setDraft]=useState(()=>drafts.get(key)||{text:'',requestId:crypto.randomUUID()});
 const [saving,setSaving]=useState(false);
 const [error,setError]=useState('');
 const busy=useRef(false),alive=useRef(true),input=useRef<HTMLTextAreaElement>(null);
 React.useEffect(()=>{alive.current=true;return()=>{alive.current=false;};},[]);
 const resize=()=>{const el=input.current;if(el){el.style.height='auto';el.style.height=Math.min(el.scrollHeight,parseFloat(getComputedStyle(el).maxHeight)||250)+'px';}};
 useLayoutEffect(resize,[draft.text]);
 React.useEffect(()=>{const el=input.current;if(!el||typeof ResizeObserver==='undefined')return;let width=el.clientWidth;const observer=new ResizeObserver(()=>{if(el.clientWidth!==width){width=el.clientWidth;resize();}});observer.observe(el);return()=>observer.disconnect();},[]);
 const save=async()=>{
  if(busy.current||!draft.text.trim())return;
  busy.current=true;setSaving(true);setError('');
  try {
   await api.post('/internal-notes/',{wa_id:waId,body:draft.text,request_id:draft.requestId},{timeout:20000});
   drafts.delete(key);
   PubSub.publish(EVENT_TOPIC_FORCE_REFRESH_CHAT,{shadowSync:true,messagesChanged:true});
   if(alive.current)onClose();
  } catch(e:any) {
   if(alive.current)setError(e.response?.data?.detail||'No se ha confirmado el guardado. Puedes reintentar sin duplicar la nota.');
  } finally {busy.current=false;if(alive.current)setSaving(false);}
 };
 return <div className="cv-note-composer">
  <TypeBox className="cv-public-composer cv-note-input" style={{backgroundColor:'#eff0f2'}}>
   <textarea className="cv-composer-text" ref={input} autoFocus rows={1} aria-label="Nota interna · Solo equipo" placeholder="Nota interna · Solo equipo" maxLength={10000} value={draft.text} disabled={saving} onChange={e=>{const next={text:e.target.value,requestId:crypto.randomUUID()};drafts.set(key,next);setDraft(next);}} onKeyDown={e=>{if(e.key==='Enter'&&!e.shiftKey&&!e.nativeEvent.isComposing){e.preventDefault();void save();}}}/>
   <div className="cv-composer-toolbar">
    <IconButton type="button" disabled={saving} className="cv-composer-mode" aria-label="Cambiar a WhatsApp" onClick={onClose}><EditNote/></IconButton>
    <Tooltip title="Guardar nota interna"><span className="cv-note-save"><IconButton className="cv-composer-submit" aria-label="Guardar nota interna" disabled={saving||!draft.text.trim()} onClick={()=>void save()}><Send/></IconButton></span></Tooltip>
   </div>
  </TypeBox>
  {error&&<div className="cv-note-error" role="alert">{error}</div>}
 </div>;
}
